import { useState } from 'react';
import StatusSelect from '@components/status-select/status-select.tsx';
import { AvailabilityStatus } from '@models/global.model.ts';

const statusOptions = [
  { id: 'accepted', title: 'Accepted', value: AvailabilityStatus.Accepted },
  { id: 'ready', title: 'Ready', value: AvailabilityStatus.Ready },
  {
    id: 'in progress',
    title: 'In Progress',
    value: AvailabilityStatus.InProgress
  },
  { id: 'finished', title: 'Finished', value: AvailabilityStatus.Finished }
];

const Block = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-3">
    <p className="font-semibold text-gray-700">{title}</p>
    <div className="flex items-center gap-6">{children}</div>
  </div>
);

function StatusSelectComponent() {
  const [rowStatuses, setRowStatuses] = useState<
    Record<number, AvailabilityStatus>
  >({
    1: AvailabilityStatus.Accepted,
    2: AvailabilityStatus.InProgress
  });

  const handleUpdate = (id: number, status: string) =>
    setRowStatuses((prev) => ({ ...prev, [id]: status as AvailabilityStatus }));

  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-xl font-bold text-gray-800">Status Select</h2>

      <Block title="Editable (color-coded pill, click to change)">
        <StatusSelect
          value={rowStatuses[1]}
          rowId={1}
          optionsList={statusOptions}
          onStatusUpdate={handleUpdate}
        />
        <StatusSelect
          value={rowStatuses[2]}
          rowId={2}
          optionsList={statusOptions}
          onStatusUpdate={handleUpdate}
        />
      </Block>

      <Block title="Locked (canceled / rejected — disabled with tooltip)">
        <StatusSelect
          value={AvailabilityStatus.Canceled}
          rowId={3}
          optionsList={statusOptions}
          onStatusUpdate={handleUpdate}
        />
        <StatusSelect
          value={AvailabilityStatus.Rejected}
          rowId={4}
          optionsList={statusOptions}
          onStatusUpdate={handleUpdate}
        />
      </Block>
    </div>
  );
}

export default StatusSelectComponent;
